// Module
var code = `<h1>Email</h1> <h3 class="metric-meaning">What does it mean?</h3><p>Traffic received from email clients.</p> `;
// Exports
module.exports = code;